import React from 'react';
import { Icon } from '@iconify/react';

const AssignmentChip = ({ event, onClick, onRemove, draggable = false, onDragStart }) => {
  const badgeClass = event.kind === 'workOrder' ? 'text-muted bg-primary-focus' : 'text-muted bg-info-focus';
  const borderColor = event.kind === 'workOrder' ? 'var(--bs-primary)' : 'var(--bs-info)';
  const source = event?.original || {};
  const assetNumber = source?.assetId ? source?.asset?.assetNumber : '';
  const numberLabel = event.kind === 'workOrder'
    ? source?.workOrderNumber || 'WO'
    : event.title || 'Form';
  const titleLabel = event.kind === 'workOrder'
    ? event.title
    : source?.form?.name || source?.formName || 'Form';
  const numberWithAsset = `${numberLabel}${assetNumber ? ` (${assetNumber})` : ''}`;

  return (
    <div className='position-relative'>
      <button
        type='button'
        className={`btn btn-sm ${badgeClass} text-start p-6 mb-1 me-6`}
        onClick={() => onClick?.(event)}
        draggable={draggable}
        onDragStart={onDragStart}
        title={event.title}
        style={{
          fontSize: '0.72rem',
          lineHeight: 1.2,
          width: "100%",
          border: `solid 1px ${borderColor}`
        }}
      >
        <span className='d-block text-truncate' style={{ maxWidth: '95%' }}>{numberWithAsset}</span>
        <span className='d-block text-truncate fw-normal' style={{ maxWidth: '95%' }}>{titleLabel}</span>
      </button>
      <button
        type='button'
        className='btn btn-link text-white p-0 position-absolute border-0'
        style={{ top: '2px', right: '4px', lineHeight: 1 }}
        onClick={(e) => {
          e.stopPropagation();
          onRemove?.(event);
        }}
        aria-label='Remove assignment'
      >
        <Icon icon='mdi:close' className='text-neutral-400' width='16' height='16' />
      </button>
    </div>
  );
};

export default AssignmentChip;
